module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/ppa_presents-9ffdcda2ef138e90e14be483c614d6bd.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/ppa_presents.png
// module id = 2463
// module chunks = 2